/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import * as components from "../components/index.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export type ProjectsListProjectsResponse = {
  result: components.V1ProjectsListProjectsResponseBody;
};

/** @internal */
export const ProjectsListProjectsResponse$inboundSchema: z.ZodType<
  ProjectsListProjectsResponse,
  z.ZodTypeDef,
  unknown
> = z.object({
  Result: components.V1ProjectsListProjectsResponseBody$inboundSchema,
}).transform((v) => {
  return remap$(v, {
    "Result": "result",
  });
});

export function projectsListProjectsResponseFromJSON(
  jsonString: string,
): SafeParseResult<ProjectsListProjectsResponse, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => ProjectsListProjectsResponse$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'ProjectsListProjectsResponse' from JSON`,
  );
}
